import React from 'react';
import TelaInicialAssociado from 'components/TelaInicialAssociado/TelaInicialAssociado';

export default () => {
  return <TelaInicialAssociado />
}